<template>
  <div>
  <company-add-new
      :is-add-new-company-sidebar-active.sync="isAddNewCompanySidebarActive"
      @refetch-data="refetchData"
  />
  <b-card no-body class="mb-0">

    <div class="m-2">

      <!-- Top Controls -->
      <b-row>

        <!-- Per Page -->
        <b-col cols="12" md="6" class="d-flex align-items-center">
          <label>Show</label>

          <v-select
              v-model="perPage"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector mx-50"
          />

          <label>entries</label>
        </b-col>

        <!-- Search -->
        <b-col cols="12" md="6">
          <div class="d-flex justify-content-end">
            <b-form-input
                v-model="searchQuery"
                placeholder="Search company..."
                class="mr-1"
            />

            <b-button
                variant="primary"
                @click="isAddNewCompanySidebarActive = true"
            >
              Add Company
            </b-button>
          </div>
        </b-col>

      </b-row>

    </div>

    <!-- Loading -->
    <div class="d-flex justify-content-center">
      <b-spinner v-show="totalCompanies === null" variant="primary" />
    </div>

    <!-- Table -->
    <b-table
        ref="refCompanyTable"
        :items="fetchCompanies"
        :fields="tableColumns"
        primary-key="id"
        responsive
        show-empty
        empty-text="No matching records found"
        :per-page="perPage"
        :current-page="currentPage"
    >

      <!-- Company -->
      <template #cell(name)="data">
        <b-link class="font-weight-bold">
          {{ data.item.name }}
        </b-link>
      </template>

      <!-- Pricing -->
      <template #cell(pricing)="data">
        {{ data.item.pricing ? data.item.pricing.name : '-' }}
      </template>

      <!-- Users Count -->
      <template #cell(users_count)="data">
        <b-badge variant="light-primary">
          {{ data.item.users_count }}
        </b-badge>
      </template>

      <!-- Actions -->
      <template #cell(actions)="data">
        <b-dropdown variant="link" no-caret right>

          <template #button-content>
            <feather-icon icon="MoreVerticalIcon" size="16" />
          </template>

          <b-dropdown-item @click="viewCompany(data.item.id)">
            <feather-icon icon="EyeIcon" />
            <span class="ml-50">View</span>
          </b-dropdown-item>

          <b-dropdown-item @click="editCompany(data.item.id)">
            <feather-icon icon="EditIcon" />
            <span class="ml-50">Edit</span>
          </b-dropdown-item>

          <b-dropdown-item @click="deleteCompany(data.item.id)">
            <feather-icon icon="TrashIcon" />
            <span class="ml-50">Delete</span>
          </b-dropdown-item>

        </b-dropdown>
      </template>

    </b-table>

    <!-- Pagination -->
    <div v-if="totalCompanies > perPage" class="mx-2 mb-2">
      <b-row>

        <b-col cols="12" sm="6">
          <span class="text-muted">
            Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries
          </span>
        </b-col>

        <b-col cols="12" sm="6" class="d-flex justify-content-end">

          <b-pagination
              v-model="currentPage"
              :total-rows="totalCompanies"
              :per-page="perPage"
              first-number
              last-number
          />

        </b-col>

      </b-row>
    </div>

  </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BPagination,
  BButton, BFormInput, BDropdown, BDropdownItem, BBadge, BSpinner
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import CompanyAddNew from '@/views/menus/user/company-list/CompanyAddNew.vue'

export default {
  components: {
    CompanyAddNew,
    BCard, BRow, BCol, BTable, BPagination,
    BButton, BFormInput, BDropdown, BDropdownItem, BBadge, BSpinner,
    vSelect,
  },

  data() {
    return {
      companies: [],
      searchQuery: '',
      perPage: 10,
      currentPage: 1,
      totalCompanies: 0,

      perPageOptions: [10, 25, 50, 100],

      tableColumns: [
        { key: 'name', label: 'Company' },
        { key: 'pricing', label: 'Pricing' },
        { key: 'category_pricing', label: 'Category' },
        { key: 'users_count', label: 'Users' },
        { key: 'actions', label: 'Actions' },
      ],
    }
  },

  computed: {
    dataMeta() {
      const localItemsCount = this.companies.length

      return {
        from: this.perPage * (this.currentPage - 1) + (localItemsCount ? 1 : 0),
        to: this.perPage * (this.currentPage - 1) + localItemsCount,
        of: this.totalCompanies,
      }
    },
  },

  watch: {
    currentPage() {
      this.$refs.refCompanyTable.refresh()
    },
    perPage() {
      this.$refs.refCompanyTable.refresh()
    },
    searchQuery() {
      this.$refs.refCompanyTable.refresh()
    },
  },

  setup(){
    return {
      isAddNewCompanySidebarActive: false,
    }
  },

  methods: {
    async fetchCompanies(ctx) {
      const currentPage = ctx.currentPage || this.currentPage
      const perPage = ctx.perPage || this.perPage

      const res = await this.$http.get('/companies', {
        params: {
          page: currentPage,
          per_page: perPage,
          search: this.searchQuery,
        },
      })

      this.companies = res.data.data
      this.totalCompanies = res.data.total

      return this.companies
    },

    openCreate() {
      this.$router.push('/companies/create')
    },

    viewCompany(id) {
      this.$router.push(`/companies/${id}`)
    },

    editCompany(id) {
      this.$router.push(`/companies/${id}/edit`)
    },

    async deleteCompany(id) {
      if (!confirm('Delete this company?')) return

      await this.$http.delete(`/companies/${id}`)
      this.$refs.refCompanyTable.refresh()
    },
  },
}
</script>